import FieldMaterials from "classes/FieldMaterials";
import { postItem, putItem, deleteItem } from "utils/ApiUtils";
import ODataUtil from './ODataUtil';


const fieldmaterials_endpoint = "/FieldMaterials";

function convertImportResultToMaterial(importResult) {
  // Response structure: { data: [...materials], existing: [...ids], success: true }
  const materialsArray = importResult.data.data ? importResult.data.data : importResult.data;
  const existingIds = importResult.existing || [];

  console.log('Materials array length:', materialsArray.length);
  console.log('Existing IDs length:', existingIds.length);

  return materialsArray.map((material, index) => {
    const record = {};

    record.Supplier = material.supplier;
    record.Category = material.category;
    record.MaterialCode = material.materialCode;
    record.MaterialDesc = material.materialDesc;
    record.MaterialSub = material.materialSub;
    record.SpecItem = material.specItem;
    record.FieldMaterialId = material.fieldMaterialId;
    record.IsActive = material.isActive;
    record.AddedBy = material.addedBy;
    record.ProjectId = material.projectId;
    record.DateAdded = new Date().toISOString();

    // Check for validation errors (notes starts with "ERROR:")
    if (material.notes && material.notes.startsWith("ERROR:")) {
      record.Error = material.notes.replace("ERROR:", "");
    }

    // Mark existing records as updates - they have non-required field changes (MaterialDesc, Category)
    // Records with no changes are already filtered out by the backend
    const isExisting = existingIds.includes(material.fieldMaterialId);
    if (isExisting && !record.Error) {
      record.IsUpdate = true;
    }

    // Debug first few records
    if (index < 3) {
      console.log(`Record ${index}: fieldMaterialId=${material.fieldMaterialId}, isExisting=${isExisting}, IsUpdate=${record.IsUpdate}, Error=${record.Error}`);
    }

    return new FieldMaterials(record);
  });
};


async function getProjectMaterials(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = FieldMaterials;
  const endpoint = fieldmaterials_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, {model, endpoint});
  return data;
}


async function uploadFieldMaterials(value, projectId) {
  const resourcePath = `${fieldmaterials_endpoint}/uploadexcel`;
  const params = `?projectId=${projectId}`;
  const result = await postItem(resourcePath, params, value, true, false);
  return result;
}

async function addMaterial(projectId, data) {
  data.projectId = projectId
  data.materialCode = data.MaterialCode
  data.materialDesc = data.MaterialDesc
  data.materialSub = data.MaterialSub
  data.specItem = data.SpecItem
  data.supplier = data.Supplier
  data.FieldForms = data.FieldFormId
  const resourcePath = `${fieldmaterials_endpoint}/Add`;
  const params = `?projectId=${projectId}`;
  const result = await postItem(resourcePath, params, [data], false, true);
  return result
};

function applyMaterialDefaults(data, defaults) {
  data.FieldMaterialId = defaults.FieldMaterialId || defaults.fieldMaterialId
  data.AddedBy = defaults.AddedBy;
  data.DateAdded = defaults.DateAdded;
  data.ProjectId = defaults.ProjectId;
  data.Error = defaults.Error;
  return data;
}

async function updateMaterial(selectedProject, data, defaults) {
  const _data = data;
  if (!_data.FieldForms) _data.FieldForms = []
  else _data.FieldForms = _data.FieldFormId;
  data.projectId = selectedProject.ProjectId;
  applyMaterialDefaults(data, defaults);
  const resourcePath = `${fieldmaterials_endpoint}/Edit`;
  const params = `?projectId=${selectedProject.ProjectId}`;
  const result = await putItem(resourcePath, params, _data, true)
  return result
};


async function importMaterials(data) {
  const _data = data.map(i => {
    const _new = { ...i };
    if (!_new.FieldForms) _new.FieldForms = []
    else _new.FieldForms = _new.FieldFormId;
    return _new;
  });
  const resourcePath = `${fieldmaterials_endpoint}/ImportMaterials`
  const params = ''
  const result = await postItem(resourcePath, params, _data, false, true)
  return result
}


async function deleteMaterials(projectId, material) {
  const resourcePath = `${fieldmaterials_endpoint}/Delete`
  const result = await deleteItem(resourcePath, '', material)
  return result
}


export { getProjectMaterials, uploadFieldMaterials, updateMaterial, addMaterial, importMaterials, deleteMaterials, convertImportResultToMaterial, applyMaterialDefaults };